export const theme = {
    colors: {
        primary: '#2F66A6', // Navy blue - main theme color
        primaryDark: '#1C4A7A',
        primaryLight: '#4A88C6',
        secondary: '#2F66A6', // Same as primary for consistency
        secondaryDark: '#1C4A7A',
        secondaryLight: '#4A88C6',
        accent: '#2F66A6', // Blue accent
        background: '#F5F5F5',
        surface: '#FFFFFF',
        error: '#D32F2F',
        success: '#388E3C',
        warning: '#F57C00',
        info: '#2F66A6',
        text: '#212121',
        textSecondary: '#757575',
        textLight: '#BDBDBD',
        border: '#E0E0E0',
        divider: '#EEEEEE',
        disabled: '#BDBDBD',
        backdrop: 'rgba(0, 0, 0, 0.5)',
        // Design-specific colors
        headerBackground: '#2F66A6',
        cardBackground: '#FFFFFF',
        profit: '#388E3C',
        loss: '#D32F2F',
        milk: '#2F66A6',
        feed: '#8BC34A',
        medicine: '#E91E63',
    },
    spacing: {
        xs: 4,
        sm: 12,
        md: 16,
        lg: 24,
        xl: 32,
        xxl: 48,
    },
    borderRadius: {
        sm: 4,
        md: 8,
        lg: 12,
        xl: 16,
        round: 9999,
    },
    typography: {
        h1: {
            fontSize: 32,
            fontWeight: '700' as const,
            lineHeight: 40,
        },
        h2: {
            fontSize: 28,
            fontWeight: '700' as const,
            lineHeight: 36,
        },
        h3: {
            fontSize: 24,
            fontWeight: '600' as const,
            lineHeight: 32,
        },
        h4: {
            fontSize: 20,
            fontWeight: '600' as const,
            lineHeight: 28,
        },
        h5: {
            fontSize: 18,
            fontWeight: '600' as const,
            lineHeight: 24,
        },
        h6: {
            fontSize: 16,
            fontWeight: '600' as const,
            lineHeight: 22,
        },
        body1: {
            fontSize: 16,
            fontWeight: '400' as const,
            lineHeight: 24,
        },
        body2: {
            fontSize: 14,
            fontWeight: '400' as const,
            lineHeight: 20,
        },
        caption: {
            fontSize: 12,
            fontWeight: '400' as const,
            lineHeight: 16,
        },
        button: {
            fontSize: 16,
            fontWeight: '600' as const,
            lineHeight: 24,
        },
    },
    shadows: {
        sm: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
            // @ts-ignore - Web-specific style
            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
        },
        md: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.15,
            shadowRadius: 4,
            elevation: 4,
            // @ts-ignore - Web-specific style
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
        },
        lg: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.2,
            shadowRadius: 8,
            elevation: 8,
            // @ts-ignore - Web-specific style
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
        },
    },
};

export type Theme = typeof theme;
